import React, { useContext, useState } from 'react';
import Home from '../../pages/index';

//============================================
//Context for Compliance and Implementation Scores
export const Context_Compliance_Scores = React.createContext([{}, () => { }]);

//============================================
//Context for Selection of Business Models
export const Context_Business_Models = React.createContext([{}, () => { }]);

//============================================
//Context for Selection of Laws
export const Context_Explore_Laws = React.createContext([{}, () => { }]);

//============================================
//Context for Subscription Program
export const Context_Subscription = React.createContext([{}, () => { }]);

//============================================
//Context for MSB Program
export const Context_MSB = React.createContext([{}, () => { }]);

//============================================
//Context for MSB FOREX Program
export const Context_MSB_Dealer_FOREX = React.createContext([{}, () => { }]);

//============================================
//Context for MSB Check Casher Program
export const Context_MSB_Check_Casher = React.createContext([{}, () => { }]);

//============================================
//Context for Traveler's Checks Program
export const Context_MSB_Traveler = React.createContext([{}, () => { }]);

//============================================
//Context for MOs Program
export const Context_MSB_MO = React.createContext([{}, () => { }]);

//============================================
//Context for MOs Program
export const Context_MSB_MoneyTransmitter = React.createContext([{}, () => { }]);

//============================================
//Context for MOs Program
export const Context_Loyalty_Program = React.createContext([{}, () => { }]);


//============================================
//Context for Navigation
export const Context_Navigation = React.createContext([{}, () => { }]);

//============================================
//Context for User Info
export const Context_UserInformation = React.createContext([{}, () => { }]);



export function ContextProvider(props) {

//============================================
//Global variables for Compliance and Implementation Scores
// 2020.04.28 - Can delete regulatoryComplexity and regulatoryComplexity, removed from Subscription_W_Recurring_Main.js
  var Compliance_Scores_Data_GL = { complianceScore: 0, regulatoryComplexity: "Analyzing...", completionPercent: 0, Checking_Comp_With: "Analyzing..."};

  const [Compliance_Scores_Data_GVars, Update_Compliance_Scores_Data_GVars] = useState(Compliance_Scores_Data_GL);


//============================================
//Global variables for Analysis - Level 1 - Business Models
var Business_Models_Data_GL = {BusinessModel_Selected: null, BusinessModels_Array:[
  { value: 'Reset', label: " << Reset >>", text: "Please select a business model to start the analysis:" },
  { value: 'subscription_Program', label: 'Subscription Program', text: "Subscription Business Model" },
  { value: 'MSB', label: 'Money Services Business (MSB)', text: "Money Services Business (MSB) Business Model" },
  
  {
    value: 'MSB_Dealer_Forex', label: 'Dealer in Foreign Exchange (MSB)', 
    text: "Dealer in Foreign Exchange (a type of Money Services Business - MSB)" },
  { value: 'MSB_Check_Casher', label: 'Check Casher (MSB)', text: "Check Casher (a type of Money Services Business - MSB)" },
  {
    value: 'MSB_Traveler_Checks', label: 'Issuer or seller of traveler checks (MSB)', text: "Issuer or seller of Traveler Checks (a type of Money Services Business - MSB)"
  },
    {
    value: 'MSB_Money_Orders', label: 'Issuer or seller of money orders (MSB)', text: "Issuer or Seller of Money Orders (a type of Money Services Business - MSB)"
  },
  { value: 'Loyalty_Program', label: 'Loyalty, Reward or Promotional Program', text: "You have selected a loyalty, reward or promotional program." },

      {
    value: 'MSB_Money_Transmitter', label: 'Money Transmitter (MSB)', text: "Money Transmitter (a type of Money Services Business - MSB)"
  },
      {
    value: 'MSB_Provider_Prepaid_Access', label: '[Provider of prepaid access (MSB)]', text: "Provider of Prepaid Access (a type of Money Services Business - MSB)"
  },

  {
    value: 'MSB_Seller_Prepaid_Access', label: '[Seller of prepaid access (MSB)]', text: "Seller of Prepaid Access (a type of Money Services Business - MSB)"
  },
  { value: 'prepaid_Cards', label: '[Prepaid cards or accounts]', text: "You have selected a prepaid program." },
  { value: 'remittance', label: '[Money transfer or remittance]', text: "You have selected a program for transferring money among users (a remittance program)." },
  { value: 'gift', label: '[Gift cards or certificates]', text: "You have selected a program for gift cards or gift certificates." },
  { value: 'consumer_Lending', label: '[Consumer lending]', text: "You have selected a program for issuing loans or other credit to consumers." },
  { value: 'business_Lending', label: '[Business lending]', text: "You have selected a program for issuing loans or other credit to businesses." },
  { value: 'E_Commerce_B2C', label: '[General B2C E-Commerce]', text: "You have selected a general E-Commerce program for consumers (B2C E-Commerce)." },
  { value: 'E_Commerce_B2B', label: '[General B2B E-Commerce]', text: "You have selected a general E-Commerce program for businesses (B2B E-Commerce)." },
  { value: 'Crypto_Payments', label: '[Cryptocurrency payments]', text: "You have selected a program for making B2B or B2C payments using one or more cryptocurrencies." }
]};

  const [Business_Models_GVars, Update_Business_Models_GVars] = useState(Business_Models_Data_GL);

  //============================================
  //Global variables for Analysis - Level 1 - Business Models
  var Laws_Data_GL = {
    ExploreLaws_Selected: null, Laws_Array: [
      { value: 'Reset', label: " << Reset >>", text: "Please select a law or topic to start the analysis:" },
      { value: 'Regulation_E', label: 'Regulation E', text: "Regulation E" },
      { value: 'Remittance_Transferrs_Reg_E', label: 'Remittance Transfers (Regulation E)', text: "Remittance Transfers (Regulation E)" },
      { value: 'MSB_Laws', label: 'Money Services Business (MSB) Laws', text: "Money Services Business (MSB) Laws" }
    ]
  };

  const [Explore_Laws_GVars, Update_Explore_Laws_GVars] = useState(Laws_Data_GL);

  //============================================
  //Global variables for Subscription Program
  var Subscription_Data_GL = {
     StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false, false, false], Questions_Status_String: "1 - 2 - 3 - 4" },
    CollectingData: true,
    S1_Payment_Interval:
      { Interval_Regular: false, Interval_Variable: false },
    S2_Payment_Instrument:
      { CreditCard: false, Debit: false, ACH: false, Crypto: false },
    S3_Consumer_or_Business:
      { Consumer_Over_18: false, Consumer_13_to_18: false, Consumer_Under_13: false, Business: false },
    S4_Geography:
      { US: false, International: false},
    S5_Consumer_Proximity:
      { Direct: false, Through_ThirdParty: false}
  }
  const [Subscription_GVars, Update_Subscription_GVars] = useState(Subscription_Data_GL);


  //============================================
  //Global variables for MSB Program
  var MSB_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false], Questions_Status_String: "1"  },
    S1_MSB_Prongs:
      { Currency_Dealer: false, Check_Casher: false, Issuer_Traveler_Checks: false, Prepaid_Access_Provider: false, Money_Transmitter: false, USPS: false, Prepaid_Access_Seller: false}
  }
  const [MSB_GVars, Update_MSB_GVars] = useState(MSB_Data_GL);

   //============================================
  //Global variables for MSB_Dealer_FOREX Program
  var MSB_FOREX_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false], Questions_Status_String: "1 - 2"},
    Currency_Exchange:
      { Yes: false, No: false },
    Over_1K:
      { Yes: false, No: false }
  }
  const [MSB_Dealer_FOREX_GVars, Update_MSB_Dealer_FOREX_GVars] = useState(MSB_FOREX_Data_GL);

  //============================================
  //Global variables for MSB_Check_Casher Program
  var MSB_Check_Casher_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false, false], Questions_Status_String: "1 - 2 - 3" },
    Accepts_Checks:
      { Yes: false, No: false },
    Over_1K:
      { Yes: false, No: false },
    Exceptions:
      { Exception_1: false, Exception_2: false, Exception_3: false, Exception_4: false, Exception_5: false, No_Exception: false}
  }

  const [MSB_Check_Casher_GVars, Update_MSB_Check_Casher_GVars] = useState(MSB_Check_Casher_Data_GL);
  


  //============================================
  //Global variables for Traveler's Checks
  var MSB_Traveler_GVars_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false], Questions_Status_String: "1 - 2" },
    Show_Help_Modal: false,
    Issue_Sell_TC:
      { Yes: false, No: false },
    Over_1K:
      { Yes: false, No: false }
  }

  const [MSB_Traveler_GVars, Update_MSB_Traveler_GVars] = useState(MSB_Traveler_GVars_Data_GL);

  //============================================
  //Global variables for Money Orders Program
  var MSB_MO_GVars_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false], Questions_Status_String: "1 - 2" },
    Issue_Sell_MO:
      { Yes: false, No: false },
    Over_1K:
      { Yes: false, No: false }
  }

  const [MSB_MO_GVars, Update_MSB_MO_GVars] = useState(MSB_MO_GVars_Data_GL);


  //============================================
  //Global variables for Loyalty Program
  var Loyalty_Program_GVars_Data_GL = {
    StepTracker:
      { CurrentStep: 1, Questions_Status: [false, false, false, false, false, false], Questions_Status_String: "1 - 2 - 3 - 4 - 5 - 6" },
    Card:
      { Yes: false, No: false },
    Prepaid:
      { Yes: false, No: false },
    Personal:
      { Yes: false, No: false },
    Consumer:
      { Yes: false, No: false },
    Loyalty:
      { Yes: false, No: false },
    Redeemable:
      { Yes: false, No: false }
  }

  const [Loyalty_Program_GVars, Update_Loyalty_Program_GVars] = useState(Loyalty_Program_GVars_Data_GL);


//============================================
//Global variables for Money Transmitter Program
var MSB_MoneyTransmitter_GVars_Data_GL = {
  StepTracker:
    { CurrentStep: 1, Questions_Status: [false, false, false, false, false, false, false, false], Questions_Status_String: "1 - 2 - 3 - 4 - 5 - 6 - 7 - 8" },
  Show_Help_Modal: false,
  Provide_MonTransmission:
    { Yes: false, No: false },
  Services_for_MT:
    { Yes: false, No: false }, 
  Payment_Processor:
    { Yes: false, No: false }, 
  Clearance_Operator:
    { Yes: false, No: false }, 
  Physical_Transp:
    { Yes: false, No: false }, 
  Prepaid_Access:
    { Yes: false, No: false }, 
  Integral_to_Goods:
    { Yes: false, No: false }, 
  Infrequent:
    { Yes: false, No: false }
}

const [MSB_MoneyTransmitter_GVars, Update_MSB_MoneyTransmitter_GVars] = useState(MSB_MoneyTransmitter_GVars_Data_GL);


  //============================================
  //Global variables for navigation
  var Navigation_GL = { statusBox: true, showMainMenu: false, index: true, welcomeText: true, index_ShowGoals: false, index_ShowTopics: false, index_ShowLegalAreas: false, index_ShowHow: false, index_ShowIndustries: false, index_ShowNews: true, GetBusinessModels: true, GetLaws: true, MSBForex_Page: false, Subscription_Page: false, MSB_Page: false, MSB_Check_Casher_Page: false, MSB_Traveler_Page: false, MSB_MO_Page: false, MSB_Prepaid_Access_Provider_Page: false, MSB_Money_Transmitter_Page: false, MSB_Prepaid_Access_Seller_Page: false, Loyalty_Program_Page: false, Law_Regulation_E_Page: false, Law_Remittance_Transfers_Regulation_E_Page: false, Law_MSB_Laws_Page: false };

  const [Navigation_GVars, Update_Navigation_GVars] = useState(Navigation_GL);


  //============================================
  //Global variables for user info
  var UserInfo_GL = { User_First: 'Marius', User_Last: 'Domokos', email: 'marius@svskyline.com', phone: '650.804.2647', Company_Name: 'Compliance Secant, Inc.', Send_Session: false};

  const [UserInfo_GVars, Update_UserInfo_GVars] = useState(UserInfo_GL);

//The following sets up the context (can have more than one context)
//It does not appear that we can specify any context consumers here
  return (
    <div>
      <Context_Navigation.Provider value={[Navigation_GVars, Update_Navigation_GVars]}>
      <Context_Compliance_Scores.Provider value={[Compliance_Scores_Data_GVars, Update_Compliance_Scores_Data_GVars]}>
        <Context_Business_Models.Provider value={[Business_Models_GVars, Update_Business_Models_GVars]}>
            <Context_Explore_Laws.Provider value={[Explore_Laws_GVars, Update_Explore_Laws_GVars]}>
                      
            <Context_Subscription.Provider value={[Subscription_GVars, Update_Subscription_GVars]}>

            <Context_MSB.Provider value={[MSB_GVars, Update_MSB_GVars]}>
            <Context_MSB_Dealer_FOREX.Provider value={[MSB_Dealer_FOREX_GVars, Update_MSB_Dealer_FOREX_GVars]}>  
                  <Context_MSB_Check_Casher.Provider value={[MSB_Check_Casher_GVars, Update_MSB_Check_Casher_GVars]}> 
                    <Context_MSB_Traveler.Provider value={[MSB_Traveler_GVars, Update_MSB_Traveler_GVars]}> 
                      
          <Context_MSB_MO.Provider value={[MSB_MO_GVars, Update_MSB_MO_GVars]}>
                          
          <Context_MSB_MoneyTransmitter.Provider value={[MSB_MoneyTransmitter_GVars, Update_MSB_MoneyTransmitter_GVars]}>
        
         <Context_Loyalty_Program.Provider value={[Loyalty_Program_GVars, Update_Loyalty_Program_GVars]}>
                          
            <Context_UserInformation.Provider value={[UserInfo_GVars, Update_UserInfo_GVars]}>
                          
              {props.children}
            
            </Context_UserInformation.Provider>

        </Context_Loyalty_Program.Provider>
                            
        </Context_MSB_MoneyTransmitter.Provider>
        </Context_MSB_MO.Provider>
                    
                    </Context_MSB_Traveler.Provider>
            </Context_MSB_Check_Casher.Provider>
            </Context_MSB_Dealer_FOREX.Provider>
            </Context_MSB.Provider>
          </Context_Subscription.Provider>
              
        </Context_Explore_Laws.Provider>    
            
        </Context_Business_Models.Provider>
      </Context_Compliance_Scores.Provider>
     </Context_Navigation.Provider>

      
      
    </div>
  );
}


//The broadcaster does not seem to help with any top level components or functions (i.e.,g somethign that is loaded at the top of a page, like business_models.js)
/*
const ContextBroadcaster = () => {
  return (

      <div>
      <ContextProvider>
        {console.log("inside ContextBroadcaster")}
        <ComplianceAnalysis/>
</ContextProvider>
      </div>

  );
}

export default ContextBroadcaster;
*/